'use client';

import { ProjectActionsMenu } from './ProjectActionsMenu';
import { ProjectSwitcher } from './ProjectSwitcher';

interface ProjectHeroSectionProps {
  projectName: string;
  projectId?: string;
}

export function ProjectHeroSection({
  projectName,
  projectId,
}: ProjectHeroSectionProps) {
  return (
    // Apple Health-style header (mirrors the Apple `ProjectHeroSection`): a
    // large leading title over a soft teal wash that fades into the page
    // background. No house photo, no subtitle. The wash uses the brand teal
    // (H=177°, S=90%) in the light shade tuned on Apple — top → transparent.
    <header className="relative w-full">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-[180%]"
        style={{
          background:
            'linear-gradient(to bottom, rgba(64,232,223,0.5) 0%, rgba(64,232,223,0) 100%)',
        }}
      />

      <div className="relative max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Floating controls. The building page is the app home, so there is no
            back button — only the trailing ⋮ menu (rename / delete /
            create-building). The building switcher now lives in the title
            below. */}
        <div className="flex items-center justify-end pt-3 min-h-9">
          <ProjectActionsMenu variant="hero" />
        </div>

        {/* Large leading title (dark), aligned with the content sections below.
            When there is more than one building the title doubles as the
            building switcher (title + up/down chevron); a single building shows
            a plain title. Mirrors the Apple hero. */}
        <ProjectSwitcher
          variant="title"
          currentProjectId={projectId}
          currentProjectName={projectName}
        />
      </div>
    </header>
  );
}
